import { HEX_253548, HEX_646A7E, HEX_66AAFF, HEX_FCFDFE } from '@tanium/colors';
import { defineColor } from '@tanium/react-theme-definition';

export const IconFill = defineColor([HEX_646A7E, HEX_66AAFF]);
export const IconForeground = defineColor([HEX_FCFDFE, HEX_253548]);
